export default {
  container: 'w-[222px] bg-color-white z-auto px-[16px] py-[12px] rounded-lg',
  itemWrapper: 'flex items-center gap-[12px] p-[10px] rounded-lg hover:bg-[#F0F3F6] cursor-pointer',
  itemText: 'font-inter text-[16px] text-color-text',
  separator: 'h-[1px] bg-[#E7E8EA] my-[4px]',
  labelWrapper: 'h-[44px] w-fit flex items-center gap-[8px] rounded-lg px-[12px] bg-[#FDF0E9] cursor-pointer select-none hover:brightness-[0.98] transition duration-300',
  letterWrapper: 'w-[28px] h-[28px] flex items-center justify-center rounded-full bg-[#EC6D25]',
  letter: 'text-color-white uppercase',
  name: 'font-inter text-[16px] capitalize',
  notification: 'relative',
  notificationCount: 'absolute inline-block w-[14px] h-[14px] bg-[#F04438] rounded-full flex justify-center items-center text-[10px] text-[white] align-right ml-[12px]',
};
